module.exports = __webpack_public_path__ + "assets/fonts/MiloOffc-Light.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/milo-light/MiloOffc-Light.eot
// module id = 513
// module chunks = 0